import mergeOverrideTypePolicy from './type-policy/merge-override-type-policy';

export default {
  DealStatus: {
    fields: {
      deals: mergeOverrideTypePolicy,
    },
  },
  Deal: {
    fields: {
      sponsors: mergeOverrideTypePolicy,
      brokers: mergeOverrideTypePolicy,
      lenders: mergeOverrideTypePolicy,
      allocationItems: mergeOverrideTypePolicy,
    },
  },
  Portfolio: {
    fields: {
      assets: mergeOverrideTypePolicy,
    },
  },
  Asset: {
    fields: {
      sellers: mergeOverrideTypePolicy,
      types: mergeOverrideTypePolicy,
      allocationItems: mergeOverrideTypePolicy,
      options: mergeOverrideTypePolicy,
      tags: mergeOverrideTypePolicy,
    },
  },
  Activity: {
    fields: {
      dealContacts: mergeOverrideTypePolicy,
      options: mergeOverrideTypePolicy,
      tags: mergeOverrideTypePolicy,
    },
  },
  Account: {
    fields: {
      settings: mergeOverrideTypePolicy,
    },
  },
  User: {
    fields: {
      assetTypes: mergeOverrideTypePolicy,
      accountUserDeals: mergeOverrideTypePolicy,
      accountUserPortfolios: mergeOverrideTypePolicy,
      userAccountOperations: mergeOverrideTypePolicy,
    },
  },
  Comment: {
    fields: {
      attachments: mergeOverrideTypePolicy,
      links: mergeOverrideTypePolicy,
    },
  },
  Contact: {
    fields: {
      groups: mergeOverrideTypePolicy,
      assetTypes: mergeOverrideTypePolicy,
      relatedContacts: mergeOverrideTypePolicy,
      addresses: mergeOverrideTypePolicy,
      tags: mergeOverrideTypePolicy,
    },
  },
  PortfolioGroup: {
    fields: {
      portfolios: mergeOverrideTypePolicy,
    },
  },
  DealTask: {
    fields: {
      subTasks: mergeOverrideTypePolicy,
      reviews: mergeOverrideTypePolicy,
    },
  },
};
